import React from 'react';
import { Switch } from 'react-router-dom';

import Home from '../components/pages/home/Home';
import AcerdaDe from '../components/pages/about/About';
import Faq from "../components/pages/faq/Faq";
import Mentor from '../components/pages/mentor/Mentor';
import EncuentraMentor from '../components/pages/encuentraMentor/EncuentraMentor';
import Login from '../components/pages/login/Login';
import MiPerfil from '../components/pages/miPerfil/MiPerfil';
import Disponibilidad from '../components/pages/disponibilidad/Disponibilidad';
import Categorias from '../components/pages/categorias/Categorias';
import MisMentorias from '../components/pages/misMentorias/MisMentorias';
import PrivateRoute from './PrivateRoute';
import PublicRoute from "./PublicRoute";
import PrivadidadAlumnos from '../components/pages/avisoPrivacidad/PrivacidadAlumnos';
import PrivadidadMentores from '../components/pages/avisoPrivacidad/PrivacidadMentores';
import Recursos from '../components/pages/recursos/Recursos';
import { Route } from 'react-router';

const PagesRouter = () => {




  return (
    <div>
      <Switch>
        <PublicRoute restricted={true} exact path="/" component={Home} />
        <PublicRoute restricted={false} exact path="/about" component={AcerdaDe} />
        <PublicRoute restricted={false} exact path="/faq" component={Faq} />
        <PublicRoute restricted={true} exact path="/quiero-ser-mentor" component={Mentor} />
        <PublicRoute restricted={true} path="/encuentra-tu-mentor" component={EncuentraMentor} />
        <PublicRoute restricted={true} path="/login" component={Login} />
        <PublicRoute restricted={false} path="/Home/AvisoPrivacidadAlumnos" component={PrivadidadAlumnos} />
        <PublicRoute restricted={false} path="/Home/AvisoPrivacidadMentores" component={PrivadidadMentores} />
        <PrivateRoute exact path="/mi-perfil" component={MiPerfil} />
        <PrivateRoute exact path="/mi-disponibilidad" component={Disponibilidad} />
        <PrivateRoute exact path="/recursos" component={Recursos} />
        <PrivateRoute exact path="/categorias" component={Categorias} />
        <PrivateRoute exact path="/mis-mentorias" component={MisMentorias} />
        {/* <PublicRoute restricted={false} exact path="/mis-mentorias" component={MisMentorias} /> */}
      </Switch>
    </div>
  )
}

export default PagesRouter;
